import React from 'react'
import PropTypes from 'prop-types'
import styles from './svg.module.scss'

const Question = ({ color }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#40C3AE"
        d="M16.4513 20.7376C16.4428 20.7373 16.4392 20.7369 16.4415 20.7348C15.0956 21.3992 13.6085 21.75 12.0728 21.75C6.64944 21.75 2.25 17.3864 2.25 12C2.25 6.61357 6.64944 2.25 12.0728 2.25C17.4961 2.25 21.8955 6.61357 21.8955 12C21.8955 13.6071 21.5027 15.1598 20.7623 16.5501C20.7635 16.6284 20.7785 16.7451 20.8086 16.8939C20.8661 17.1777 20.9568 17.4972 21.1388 18.0809L21.1633 18.1591C21.4096 18.9475 21.4923 19.231 21.5674 19.5937C21.7181 20.3207 21.7058 20.8134 21.2803 21.2335C20.6602 21.8456 20.3003 21.7776 18.1064 21.1314L18.0816 21.1241C17.4307 20.9324 17.1254 20.8491 16.829 20.7896C16.6668 20.757 16.539 20.7399 16.4513 20.7376ZM18.6146 19.4062L18.5897 19.3989C16.8179 18.8771 16.3281 18.7787 15.7019 19.0939C14.5873 19.6551 13.3525 19.9515 12.0728 19.9515C7.63946 19.9515 4.04852 16.3898 4.04852 12C4.04852 7.61018 7.63946 4.04852 12.0728 4.04852C16.5061 4.04852 20.097 7.61018 20.097 12C20.097 13.3352 19.7653 14.621 19.1401 15.7693C18.7928 16.4073 18.9036 16.9542 19.4219 18.6163L19.4466 18.6955C19.6097 19.2173 19.6946 19.4982 19.7511 19.7197C19.4997 19.6628 19.1922 19.5763 18.6146 19.4062ZM11.1058 11.6803C10.9168 11.9863 10.8223 12.3643 10.8223 12.8143V13.3003H12.5638V12.9088C12.5638 12.7198 12.5863 12.5623 12.6313 12.4363C12.6853 12.3103 12.7843 12.1798 12.9283 12.0448C13.0723 11.9098 13.2748 11.7478 13.5358 11.5588C13.8868 11.2978 14.1793 11.0548 14.4133 10.8298C14.6473 10.5958 14.8228 10.3438 14.9398 10.0738C15.0568 9.80383 15.1153 9.48433 15.1153 9.11533C15.1153 8.42233 14.8543 7.85083 14.3323 7.40083C13.8193 6.95083 13.0948 6.72583 12.1588 6.72583C11.5468 6.72583 10.9843 6.80233 10.4713 6.95533C9.95828 7.10833 9.48128 7.30633 9.04028 7.54933L9.75578 8.99383C10.1428 8.79583 10.5208 8.63833 10.8898 8.52133C11.2588 8.40433 11.6323 8.34583 12.0103 8.34583C12.3883 8.34583 12.6808 8.42233 12.8878 8.57533C13.1038 8.71933 13.2118 8.93533 13.2118 9.22333C13.2118 9.51133 13.1218 9.76333 12.9418 9.97933C12.7708 10.1863 12.4828 10.4338 12.0778 10.7218C11.6188 11.0548 11.2948 11.3743 11.1058 11.6803ZM10.9438 14.6908C10.7188 14.8528 10.6063 15.1408 10.6063 15.5548C10.6063 15.9508 10.7188 16.2388 10.9438 16.4188C11.1688 16.5898 11.4433 16.6753 11.7673 16.6753C12.0823 16.6753 12.3523 16.5898 12.5773 16.4188C12.8023 16.2388 12.9148 15.9508 12.9148 15.5548C12.9148 15.1408 12.8023 14.8528 12.5773 14.6908C12.3523 14.5198 12.0823 14.4343 11.7673 14.4343C11.4433 14.4343 11.1688 14.5198 10.9438 14.6908Z"
      />
      <g fill="none" fillRule="evenodd">
        <mask id="prefix__b" fill="#fff">
          <use xlinkHref="#question" />
        </mask>
        <use
          className={styles[color]}
          fillRule="nonzero"
          xlinkHref="#question"
        />
        <g mask="url(#prefix__b)">
          <path d="M0 0H48V48H0z" />
        </g>
      </g>
    </svg>
  )
}

Question.propTypes = {
  color: PropTypes.oneOf([
    'primaryColor',
    'darkColor',
    'whiteColor',
    'greenColor',
  ]),
}

Question.defaultProps = {
  color: 'primaryColor',
}

export default Question
